import {ReactNode} from "react";

import {getPlanner3dData, Planner3DTypes} from "../../../constants/get_planner_3d_data";
import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";
import {YslabProperty} from "./api/yslab_investments_api";
import {Planner3DImakeable} from "./Planner3DImakeable";
import {YslabPlanner3d} from "./Planner3DYslab";

interface Props {
    className?: string;
    children: ReactNode;
    vendorId: number;
    // routedModalId has to be unique across entire view
    routedModalId: string;
    offer: IMakeablePlansOffer;
    apartmentNumber?: string;
    yslabProperty?: YslabProperty;
}

export const Planner3dModal = (props: Props) => {
    const plannerData = getPlanner3dData(props.offer.id);

    switch (plannerData?.type) {
        case Planner3DTypes.YSLAB_ALLINONE:
        case Planner3DTypes.YSLAB:
            return (
                <YslabPlanner3d
                    modalId={props.routedModalId}
                    offerId={props.offer.id}
                    vendorId={props.vendorId}
                    offerName={props.offer.name}
                    yslabProperty={props.yslabProperty}
                >
                    {props.children}
                </YslabPlanner3d>
            );
        case Planner3DTypes.IMAKEABLE:
            return (
                <Planner3DImakeable offer={props.offer} modalId={props.routedModalId}>
                    {props.children}
                </Planner3DImakeable>
            );
        default:
            return null;
    }
};
import {ReactNode} from "react";

import {getPlanner3dData, Planner3DTypes} from "../../../constants/get_planner_3d_data";
import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";
import {YslabProperty} from "./api/yslab_investments_api";
import {Planner3DImakeable} from "./Planner3DImakeable";
import {YslabPlanner3d} from "./Planner3DYslab";

interface Props {
    className?: string;
    children: ReactNode;
    vendorId: number;
    // routedModalId has to be unique across entire view
    routedModalId: string;
    offer: IMakeablePlansOffer;
    apartmentNumber?: string;
    yslabProperty?: YslabProperty;
}

export const Planner3dModal = (props: Props) => {
    const plannerData = getPlanner3dData(props.offer.id);

    switch (plannerData?.type) {
        case Planner3DTypes.YSLAB_ALLINONE:
        case Planner3DTypes.YSLAB:
            return (
                <YslabPlanner3d
                    modalId={props.routedModalId}
                    offerId={props.offer.id}
                    vendorId={props.vendorId}
                    offerName={props.offer.name}
                    yslabProperty={props.yslabProperty}
                >
                    {props.children}
                </YslabPlanner3d>
            );
        case Planner3DTypes.IMAKEABLE:
            return (
                <Planner3DImakeable offer={props.offer} modalId={props.routedModalId}>
                    {props.children}
                </Planner3DImakeable>
            );
        default:
            return null;
    }
};
